<template>
    <div v-if="statusData">
        <table>
            <tr>
                <td>App Versión </td>
                <td><b>{{ statusData.appVersion }}</b></td>
            </tr>
            <tr>
                <td>Nom Versión </td>
                <td><b>{{ statusData.versionName }}</b></td>
            </tr>
            <tr>
                <td>B.Datos </td>
                <td><b>{{ statusData.currentDatabase }}</b></td>
            </tr>
            <tr>
                <td>Motor Bd</td>
                <td><b>{{ statusData.versionComment }}</b></td>
            </tr>
            <tr>
                <td>Versión Motor</td>
                <td><b>{{ statusData.mysqlVersion }}</b></td>
            </tr>
            <tr>
                <td>Ult.Migracion</td>
                <td><b>{{ statusData.lastMigration }}</b></td>
            </tr>
        </table>
        <hr>
        <b>Estado de Líneas de Producción</b>
        <table>
            <thead>
                <tr id="about-header">
                    <th>Estado</th>
                    <th>Id.Línea</th>
                    <th>Línea</th>
                    <th>Maq.Pesaje</th>
                    <th>Error</th>
                </tr>
            </thead>
            <tbody id="about-body">
                <tr v-for="(item, index) in statusData.lineStatuses" :key="index">
                    <td>{{ item.status }}</td>
                    <td>{{ item.id }}</td>
                    <td>{{ item.descrip }}</td>
                    <td>{{ item.closingMachineId }}</td>
                    <td>{{ item.error }}</td>
                </tr>
            </tbody>
        </table>
        <hr>
        <table>
            <thead>
                <tr id="about-header">
                    <th>Descripción</th>
                    <th>Id</th>
                    <th>Orden</th>
                    <th>Turno</th>
                    <th>Últ. estado</th>
                    <th>Cant. prod.</th>
                    <th>Peso acum.</th>
                    <th>Peso exc.</th>
                    <th>valor</th>
                    <th>Creación</th>
                    <th>Actualizado</th>
                </tr>
            </thead>
            <tbody id="about-body">
                <tr v-for="(machine, index) in statusData.machineStatuses" :key="index">
                    <td>{{ machine.descrip }}</td>
                    <td>{{ machine.machine_id }}</td>
                    <td>{{ machine.order_reference_id }}</td>
                    <td>{{ machine.shift_name }}</td>
                    <td>{{ machine.last_status }}</td>
                    <td>{{ machine.produced_quantity }}</td>
                    <td>{{ machine.weight_accumulated }}</td>
                    <td>{{ machine.weight_excess }}</td>
                    <td>{{ machine.unit_value }}</td>
                    <td>{{ machine.created_at }}</td>
                    <td>{{ machine.updated_at }}</td>
                </tr>
            </tbody>
        </table>
        <hr>
        <table v-if="canTestLogs" id="about-logs-test-table">
            <tr>
                <td><b>Test Log</b></td>
                <td><button class="btn btn-primary" @click="testLogs">Test</button></td>
            </tr>
            <tr>
                <td>Single</td>
                <td><b>{{ logsStatus != null ? logsStatus.log_test_single : 'Not tested' }}</b></td>
            </tr>
            <tr>
                <td>Daily</td>
                <td><b>{{ logsStatus != null ? logsStatus.log_test_daily : 'Not tested' }}</b></td>
            </tr>
            <tr>
                <td>Swal</td>
                <td><b>{{ logsStatus != null ? logsStatus.log_test_swalLog : 'Not tested' }}</b></td>
            </tr>
            <tr>
                <td>Emergency</td>
                <td><b>{{ logsStatus != null ? logsStatus.log_test_emergency : 'Not tested' }}</b></td>
            </tr>
            <tr>
                <td>topicPublishedLog</td>
                <td><b>{{ logsStatus != null ? logsStatus.log_test_topicPublishedLog : 'Not tested' }}</b></td>
            </tr>
            <tr>
                <td>bagsCountingInconsistency</td>
                <td><b>{{ logsStatus != null ? logsStatus.log_test_bagsCountingInconsistency : 'Not tested' }}</b></td>
            </tr>
            <tr>
                <td>machineRecordsLog</td>
                <td><b>{{ logsStatus != null ? logsStatus.log_test_machineRecordsLog : 'Not tested' }}</b></td>
            </tr>
        </table>
    </div>
    <div v-else>
        <p>Cargando datos...</p>
    </div>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from './utils';

export default
    {
        name: 'about-component',
        data() {
            return {
                statusData: null,
                logsStatus: null
            };
        },
        methods:
        {
            getMainData() {
                axios.get('/api/vue/status-data')
                    .then(response => {
                        this.statusData = response.data;
                    })
                    .catch(error => {
                        showCustomErrorSweetAlert(error.response.data);
                        console.error(error);
                    });
            },
            testLogs() {
                axios.get('/api/vue/logs-info')
                    .then(response => {
                        this.logsStatus = response.data;
                    })
                    .catch(error => {
                        showCustomErrorSweetAlert(error.response.data);
                        console.error(error);
                    });
            }
        },
        computed:
        {
            ...mapGetters(['isUserSuperadmin',]),
            canTestLogs() {
                return this.isUserSuperadmin;
            }
        },
        mounted() {
            this.getMainData();
        },
    };
</script>
<style lang="scss">
#about-header th:nth-child(n+2) {
    padding: 0 0 0 4ch;
}

#about-body tr td:nth-child(n+2) {
    padding: 0 0 0 4ch;
}

#about-logs-test-table tr td:nth-child(n+2) {
    padding: 0 0 0 4ch;
}

.sr-only {
    display: none;
}
</style>